// extracted by mini-css-extract-plugin
export default {"headLine":"index_headLine_4hBDD","inner":"index_inner_Ra83H","pl24":"index_pl24_LsrAl","cRed2":"index_cRed2_NAoQm","num":"index_num_mNjzS"};